<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "人员管理" },
        { name: "车队经理管理" },
      ],
      menuIndex: `/staff/manager/table`,
      menu: [
        {
          name: "在职",
          path: `/staff/manager/table/1`,
        },
        {
          name: "离职",
          path: `/staff/manager/table/2`,
        },
        {
          name: "冻结",
          path: `/staff/manager/table/3`,
        },
      ],
    };
  },
  methods: {},
  watch: {
    $route() {
      this.menuIndex = this.$route.path
    },
  },
  mounted() {
    this.menuIndex = `${this.$route.path}`
  },
};
</script>
